module.exports = __webpack_public_path__ + "static/media/img_banner.32d93be4.svg";